import { Type } from 'class-transformer';
import {
  IsDate,
  IsDefined,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { TransactionId } from '../../types';
import { SubscriptionSummaryDto } from '../users/subscription-summary.dto';
import { UserSummaryDto } from '../users/user-summary.dto';

export class TransactionStripeMetadataDto {
  @IsString()
  @IsOptional()
  invoiceId?: string;

  @IsString()
  @IsOptional()
  paymentIntentId?: string;
}

export class TransactionSummaryMetadataDto {
  @ValidateNested()
  @Type(() => TransactionStripeMetadataDto)
  @IsOptional()
  stripe?: TransactionStripeMetadataDto;
}

export class TransactionSummaryDto extends BaseDto<TransactionId> {
  @ValidateNested()
  @Type(() => SubscriptionSummaryDto)
  @IsDefined()
  subscription!: SubscriptionSummaryDto;

  @ValidateNested()
  @Type(() => UserSummaryDto)
  @IsDefined()
  user!: UserSummaryDto;

  @IsNumber()
  @IsDefined()
  amount!: number;

  @IsString()
  @IsNotEmpty()
  currency!: string;

  @IsString()
  @IsNotEmpty()
  status!: string;

  @ValidateNested()
  @Type(() => TransactionSummaryMetadataDto)
  @IsOptional()
  metadata?: TransactionSummaryMetadataDto;

  @IsDate()
  @IsDefined()
  date!: Date;
}
